import { render, staticRenderFns } from "./EN_Post.vue?vue&type=template&id=1966c906&"
import script from "./EN_Post.vue?vue&type=script&lang=js&"
export * from "./EN_Post.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports